import { render, staticRenderFns } from "./ClinicalTrials.vue?vue&type=template&id=09da9d50&scoped=true&"
var script = {}
import style0 from "./ClinicalTrials.vue?vue&type=style&index=0&id=09da9d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09da9d50",
  null
  
)

export default component.exports